import {ref} from 'vue';
import {defineStore} from 'pinia';
import {PAGINATED_RESULTS_FIELDS} from "@/utilities/enums";
import {EndpointsFactory, QUERY_FIELDS} from "../utilities/endpoints.js";
import {WorkerResponseCode} from "../utilities/workerUtilites.js";
import {useAppStore} from "@/stores/app.js";

export const useUsersStore = defineStore('users', () => {
  const users = ref([]);

  function setUsers(usersData){
    users.value = usersData;
  }

  function fetchUsers(userToken){
    const query = {[QUERY_FIELDS.page_size]: -1};
    return new Promise((resolve, reject) => {
      EndpointsFactory.execApiViaWorker({
        url: EndpointsFactory.getEndpoint(EndpointsFactory.ENDPOINTS.USERS_GET, {query_parameters: query}),
        token: userToken,
        method: 'GET'
      }, WorkerResponseCode.USERS_GET + JSON.stringify(query), ({result}) => {
        setUsers(result[PAGINATED_RESULTS_FIELDS.items]);
        resolve(result[PAGINATED_RESULTS_FIELDS.items]);
      }, () => {
        const appStore = useAppStore();
        appStore.showError();
        reject();
      });
    });
  }

  function reset(){
    users.value = [];
  }

  return {
    fetchUsers,
    setUsers,
    reset,
    users
  }
}, {
  persist: true
});
